var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImageInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M19.7708 5.12504H12.525C9.93476 5.12504 8.63964 5.12504 7.65029 5.62914C6.78004 6.07255 6.07251 6.78009 5.62909 7.65034C5.125 8.63968 5.125 9.9348 5.125 12.525V25.475C5.125 28.0653 5.125 29.3604 5.62909 30.3497C6.07251 31.22 6.78004 31.9275 7.65029 32.3709C8.63964 32.875 9.93476 32.875 12.525 32.875H26.7083C28.142 32.875 28.8589 32.875 29.447 32.7175C31.0431 32.2898 32.2898 31.0431 32.7174 29.4471C32.875 28.8589 32.875 28.1421 32.875 26.7084M29.7917 12.8334V3.58337M25.1667 8.20837H34.4167M16.6875 13.6042C16.6875 15.3071 15.307 16.6875 13.6042 16.6875C11.9013 16.6875 10.5208 15.3071 10.5208 13.6042C10.5208 11.9013 11.9013 10.5209 13.6042 10.5209C15.307 10.5209 16.6875 11.9013 16.6875 13.6042ZM23.6096 18.8739L10.5689 30.7291C9.83535 31.3959 9.4686 31.7293 9.43616 32.0182C9.40804 32.2685 9.50403 32.5168 9.69324 32.6832C9.91153 32.875 10.4072 32.875 11.3985 32.875H25.8696C28.0884 32.875 29.1977 32.875 30.069 32.5023C31.1629 32.0344 32.0343 31.1629 32.5023 30.0691C32.875 29.1978 32.875 28.0884 32.875 25.8697C32.875 25.1232 32.875 24.7499 32.7934 24.4023C32.6908 23.9654 32.4942 23.5562 32.2171 23.2032C31.9966 22.9224 31.7052 22.6892 31.1222 22.2228L26.8098 18.7729C26.2264 18.3062 25.9347 18.0728 25.6134 17.9904C25.3303 17.9178 25.0323 17.9272 24.7543 18.0175C24.4389 18.12 24.1625 18.3713 23.6096 18.8739Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageInspection);
export default __webpack_public_path__ + "static/media/icon-image-inspection.c71272720cb086847f72cfd8918a5c1a.svg";
export { ForwardRef as ReactComponent };